import { render, staticRenderFns } from "./unlockTenant.vue?vue&type=template&id=f45fb21a&scoped=true&"
import script from "./unlockTenant.vue?vue&type=script&lang=js&"
export * from "./unlockTenant.vue?vue&type=script&lang=js&"
import style0 from "./unlockTenant.vue?vue&type=style&index=0&id=f45fb21a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45fb21a",
  null
  
)

export default component.exports